import React from 'react';

export class Polygon extends React.PureComponent {
    constructor(props) {
        super(props);
        const {
            latLngs,
            strokeColor,
            strokeOpacity,
            strokeWeight,
            fillColor,
            fillOpacity,
            zIndex
        } = props;
        var polygon = new google.maps.Polygon({
            paths: latLngs,
            strokeColor,
            strokeOpacity,
            strokeWeight,
            fillColor,
            fillOpacity
        });
        if (zIndex !== null) {
            polygon.set('zIndex', zIndex);
        }
        this.state = {
            polygon
        };
    }

    UNSAFE_componentWillMount() {
        const {
            mapHelper,
            onMouseOverOnPolygon,
            onMouseOutOnPolygon,
            onMouseMoveOnPolygon,
            onMouseDownOnPolygon,
            onMouseClickOnPolygon,
            id
        } = this.props;

        const { polygon } = this.state;
        polygon.setMap(this.props.mapHelper.map);

        if (onMouseOverOnPolygon) {
            mapHelper.maps.event.addListener(polygon, 'mouseover', event => {
                onMouseOverOnPolygon(id, event, this.props);
            });
        }

        if (onMouseDownOnPolygon) {
            mapHelper.maps.event.addListener(polygon, 'mousedown', event => {
                onMouseDownOnPolygon(id, event, this.props);
            });
        }

        if (onMouseOutOnPolygon) {
            mapHelper.maps.event.addListener(polygon, 'mouseout', event => {
                onMouseOutOnPolygon(id, event, this.props);
            });
        }

        if (onMouseMoveOnPolygon) {
            mapHelper.maps.event.addListener(polygon, 'mousemove', event => {
                onMouseMoveOnPolygon(id, event, this.props);
            });
        }

        if (onMouseClickOnPolygon) {
            mapHelper.maps.event.addListener(polygon, 'click', event => {
                onMouseClickOnPolygon(id, event, this.props);
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            fillOpacity,
            strokeWeight,
            fillColor,
            strokeColor
        } = this.props;
        const { polygon } = this.state;
        let options;
        polygon.setPaths(nextProps.latLngs);
        if (fillOpacity !== nextProps.fillOpacity) {
            options = { fillOpacity: nextProps.fillOpacity };
        }
        if (strokeWeight !== nextProps.strokeWeight) {
            options = { ...options, strokeWeight: nextProps.strokeWeight };
        }
        if (fillColor !== nextProps.fillColor) {
            options = { ...options, fillColor: nextProps.fillColor };
        }
        if (strokeColor !== nextProps.strokeColor) {
            options = { ...options, strokeColor: nextProps.strokeColor };
        }
        options && polygon.setOptions(options);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.latLngs !== this.props.latLngs) return true;
        return false;
    }

    componentWillUnmount() {
        const { mapHelper } = this.props;
        const { polygon } = this.state;
        polygon.setMap(null);
        mapHelper.maps.event.clearListeners(polygon, 'mouseover');
        mapHelper.maps.event.clearListeners(polygon, 'mousemove');
        mapHelper.maps.event.clearListeners(polygon, 'mouseout');
        mapHelper.maps.event.clearListeners(polygon, 'mousedown');
        mapHelper.maps.event.clearListeners(polygon, 'click');
    }
    render() {
        return null;
    }
}

Polygon.defaultProps = {
    latLngs: [],
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillOpacity: 0.35
};

export default Polygon;
